import {
  TEAM_ID,
  SPORTRADAR_NAMES,
  buildSportradarFromName,
} from 'mm-ui-components';

type SportradarPropsType = {
  league: string;
  seasonId: number;
  widget: string;
  teamUid?: string;
  teamId?: string;
} | null;

const SEASON_ID_2024: { [key: string]: number | undefined } = {
  nba: 119257,
  mlb: 112588,
  nfl: 2024,
  nhl: 119985,
  wnba: 112470,
  ncaaf: 114685,
  ncaab: 104315,
  soccer: undefined,
};

const WIDGET_NAMES = ['SCHEDULE', 'ROSTER', 'STATS', 'DEPTH'];

const STATS: { [key: string]: string[] } = {
  default: ['_TEAM_LEADERS', '_PLAYERS_STATS', '_TEAM_STATS_GRAPHIC'],
  soccer: ['_TEAM_LEADERS', '_RANKS'],
  nfl: ['_TEAM_LEADERS', '_PLAYERS_STATS'],
  ncaaf: ['_TEAM_LEADERS', '_PLAYERS_STATS'],
};

const FOOTBALL_STATS = [
  { title: 'Passing' },
  { title: 'Rushing' },
  { title: 'Receiving' },
  { title: 'Defense' },
  { title: 'Kicking' },
  { title: 'Punting' },
  { title: 'Returns' },
];

function buildWidgetListFromPayload(pathParts: string[], widget: string, seasonId: number, teamId: string) {
  let league = Object.keys(SEASON_ID_2024)?.find(id => pathParts.includes(id));

    if (pathParts.includes('college')) {
      league = pathParts.includes('college-football') ? 'ncaaf' : 'ncaab';
    }

    if (!league) return null;

    return {
      widget,
      league,
      teamUid: teamId,
      seasonId: league !== 'soccer' ? SEASON_ID_2024[league] as number : seasonId,
    };
}

function buildWidgetListFromUrl(pathParts: string[], widget: string) {
  const league = Object.keys(TEAM_ID)?.find(id => pathParts.includes(id));

  if (!league) return null;

  const teamUid = Object.keys(TEAM_ID[league])
    .map(id => {
      if (pathParts.find(path => path.match(id))) {
        return TEAM_ID[league][id];
      }
      return null;
    })
    .filter(Boolean)[0];

  if (!teamUid) return null;

  return {
    widget,
    league,
    teamUid,
    seasonId: SEASON_ID_2024[league] as number,
  };
}

export const createSportradarProps = (canonical: string, sportradarProps?: any): SportradarPropsType => {
  const { seasonId, teamUid: teamId } = sportradarProps || {};
  const url = new URL(canonical);
  const pathParts = url.pathname.split('/').filter(Boolean);
  const widget = WIDGET_NAMES.find(path => pathParts?.includes(path.toLowerCase()));

  if (!pathParts.length || !widget) return null;

  if (seasonId && teamId) {
    return buildWidgetListFromPayload(pathParts, widget, seasonId, teamId);
  }

  return buildWidgetListFromUrl(pathParts, widget);
};

export const createWidgetName = (widgetName: string, league?: string): string => {
  if (!league) return '';

  const sportradar = `${league.toUpperCase()}${widgetName}`;

  // @ts-ignore
  return SPORTRADAR_NAMES[sportradar];
};

export const createStatsList = (league?: string, props?: { widget: string; league?: string; teamUid?: string; seasonId?: number}) => {
  if (!league) return [];

  let footballList: any[] = [];
  const sport = Object.keys(STATS).includes(league) ? league : 'default';

  const widgetList = STATS[sport].map((stat, index) => {
    const widgetName = `${league.toUpperCase()}${stat}`;
    const widgetId = `${widgetName}-${index}`;

    if ((sport === 'nfl' || sport === 'ncaaf') && index === 1) {
      footballList = FOOTBALL_STATS.map(
        // @ts-ignore
        (title, i) => buildSportradarFromName(SPORTRADAR_NAMES[widgetName], {
            widgetId: `${widgetId}${i}`,
            ...props,
            ...title,
            category: title.title.toLowerCase(),
          })[0],
      );
      return null;
    }
    // @ts-ignore
    return buildSportradarFromName(SPORTRADAR_NAMES[widgetName], props)[0];
  });

  return [...widgetList, ...footballList].filter(Boolean);
};
